import { StickyPromoBar } from "@/components/layout/StickyPromoBar";
import { StickyNavbar } from "@/components/layout/StickyNavbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingContact } from "@/components/overlays/FloatingContact";

export const SiteLayout = ({ config, availability, children }) => (
  <div className="App flex min-h-screen flex-col" style={{ background: "var(--gm-navy-950)" }}>
    <StickyPromoBar config={config} availability={availability} />
    <StickyNavbar />
    <main className="flex-1">{children}</main>
    <Footer config={config} />
    <FloatingContact config={config} />
  </div>
);
